import { render, staticRenderFns } from "./FolderTagPreview.vue?vue&type=template&id=1600f896&scoped=true"
import script from "./FolderTagPreview.vue?vue&type=script&lang=js"
export * from "./FolderTagPreview.vue?vue&type=script&lang=js"
import style0 from "./FolderTagPreview.vue?vue&type=style&index=0&id=1600f896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1600f896",
  null
  
)

export default component.exports